import { Inject, Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { LabelTranslationService } from '@openapi';

/**
 * Service for loading label translations using the ngx-translate/core module.
 * Implements the TranslateLoader interface to integrate with ngx-translate.
 */
@Injectable({
  providedIn: 'root',
})
export class LabelTranslationClientService implements TranslateLoader {
  /**
   * Constructs the service with dependency injection.
   * @param labelTranslationService - Service to fetch label translations.
   */
  constructor(
    @Inject(LabelTranslationService)
    private readonly labelTranslationService: LabelTranslationService
  ) {}

  /**
   * Retrieves translations for a specific language.
   * @param languageCode - The language code for which translations are requested.
   * @returns Observable<{ [key: string]: string }> - An observable emitting translation key-value pairs.
   */
  public getTranslation(
    languageCode: string
  ): Observable<Record<string, string>> {
    return this.labelTranslationService.getLabelTranslationByLanguageCode(
      languageCode
    );
  }
}
